'use client';

import { useTranslations } from 'next-intl';
import { toast } from '@/app/components/ui/use-toast';
import { reportEvent } from '@/app/utils';
import { ShareLivePlaybackDialog } from '../_live-records/_components';
import { getOfflineAvatarCreationShareToken } from '../apis';

interface ShareOfflineAvatarCreationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  creationId: string;
  taskId: string;
}

export function ShareOfflineAvatarCreationDialog({
  open,
  onOpenChange,
  creationId,
  taskId,
}: ShareOfflineAvatarCreationDialogProps) {
  const t = useTranslations();

  const getShareUrl = async () => {
    const { data, error } = await getOfflineAvatarCreationShareToken(creationId);
    const token = data?.token?.trim();
    if (error || !token) {
      toast({ type: 'error', message: t('liveRecords.share.tokenFailed') });
      return null;
    }
    const params = new URLSearchParams({ token });
    return `${window.location.origin}/vidu-stream/share-creation/${creationId}?${params.toString()}`;
  };

  return (
    <ShareLivePlaybackDialog
      open={open}
      onOpenChange={onOpenChange}
      playbackId={creationId}
      description={t('viduStreamOfflineAvatar.share.description')}
      getShareUrl={getShareUrl}
      onCopied={() =>
        reportEvent('operation', {
          interaction_type: 'share',
          interaction_position: 'vidu_stream_offline_avatar_profile',
          task_id: taskId,
          creation_id: creationId,
          content_type: 'video',
        })
      }
    />
  );
}
